<template>
  <div class="header  py-8 flex  justify-center bg-gray-100">
    <div class="  clearfix text-center rounded-lg ">
      <img src="images/logo.svg" class="block mb-10 mx-auto" style="max-width:400px;width:80%" alt="">

    </div>
  </div>
</template>
<script>export default {
  name: 'pa-header'
}
</script>
